import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, QueryList, ViewChildren } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import {
  AppointmentStatus,
  AppointmentStatusList,
  WorkOrderStatus,
} from '../../../business-entities/appointmentStatus-model';
import * as Enums from '../../../../../../Autofacets-Core/src/app/utils/enums';
import { BrandViewModel } from '../../../business-entities/brand-view-model';
import { UserDealersModel } from '../../../business-entities/dealer-details.model';
import { DealerViewModel } from '../../../business-entities/dealer-view-model';
import { AppointmentService } from '../../../business-services/appointment.service';
import { BrandService } from '../../../business-services/brand.service';
import { DealerBusinessService } from '../../../business-services/dealer.service';
import {
  NgbdSortableHeader,
  SortEvent,
} from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { NgxSpinnerService } from 'ngx-spinner';
import { PagerData } from '../../../business-entities/PagerData';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { VehiclePickDropListService } from '../../../business-services/vehicle-pick-drop-list.service';
import { VehiclePickupDrop } from '../../../business-entities/vehicle-pickup-drop';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { VehiclePickDropViewModel } from '../../../business-entities/vehicle-pick-drop-view-model';
import { DatePipe } from '@angular/common';
import { AppointmentList, AppointmentStatusRequestModel } from '../../../business-entities/appointmentList-model';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-pickup-dropoff',
  templateUrl: './pickup-dropoff.component.html',
})
export class PickupDropoffComponent implements OnInit {
  searchTerm: string;
  dateRangeDisp:any;
  licensePlateClass: string;
  dealerId: string = '0';
  isAdvanceSearch: any;
  selectedStatus: number;
  filterList :VehiclePickupDrop[]=[];
  bookingDate: any[] = [];
  createdDate: any[] = [];
  droptime : any = null;
  isTodayViewOn: boolean;
  isWeekViewOn: boolean;
  selectedDealer: any;
  dealerList: DealerViewModel[];
  dealers: DealerViewModel[] = [];
  appointmentStatusList: AppointmentStatusList[] = [];
  appointmentstatusList: AppointmentStatus[];
  workOrderStatusList: WorkOrderStatus[];
  workOrderStatus: WorkOrderStatus[] = [];
  brandList: BrandViewModel[];
  pickupDropoffList: any = [];
  VehiclePickDropListExcel:any;
  pagedItems: any[];
  pager: any = {};
  throttle = 100;
  scrollDistance = 1;
  VehicleListPdf: any;
  pickdroplist:any;
  totalCount: number = 0;
  rowcount : number = 0;
  pagerData: PagerData = {
    page: 1,
    pagerSize: Constant.GridPagerSize,
  };
  appointmentStatusRequestModel: AppointmentStatusRequestModel = {
    bookingDate: null,
    createdDate: null,
    dealerId: null,
    serviceAdvisorId:null,
    mechanicId:null,
    appointmentStatusId: null,
    workOrderStatusId: null,
    customerName: null,
    languageCode: null,
    licensePlate: null,
    mobileNumber: null,
    woNumber: null
  };
  appointmentList: AppointmentList[] = [];
  VehiclePickDropResponse: VehiclePickDropViewModel[]=[];
  VehiclePickDropResponseForDocument: VehiclePickDropViewModel[]=[];
  VehiclePickDroplist: VehiclePickDropViewModel[];
  customerLength : any;
 VehiclePickDropData = {
    sortColumn: '',
    sortDirection: '',
    StartRecordNumber: 0,
    DealerId: '',
    BookingDate: '',
    BookingFromDate:'',
    BookingToDate:'',
    createdDate:'',
    FromCreatedDate:'',
    ToCreatedDate:'',
    PageSize: 25,
    LanguageCode: '',
    AppointmentStatusId: null,
    WorkOrderStatusId: 0,
    SearchTerm: '',
    IsForDocuments: false,
    UserId: ''
  }
  weekViewDate:any;
todayViewDate: any;
  PickDropList: VehiclePickDropViewModel[] = [];
  myDateRangePickerOptions: Partial<BsDaterangepickerConfig> = Object.assign({},{
    containerClass: 'theme-dark-blue',
    displayMonths:1,
    showWeekNumbers:false,
    rangeInputFormat: 'DD/MM/YYYY',
    customTodayClass: 'custom-today-class'
  });

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  constructor(
    private globalSetting: GlobalSetting,
    private brandService: BrandService,
    private spinner: NgxSpinnerService,
    private cookieservice: CookieService,
    private appointmentService: AppointmentService,
    public dealerBusinessService: DealerBusinessService,
    private vehiclePickDrop: VehiclePickDropListService,
    private excelService: ExcelService,
    private datePipe: DatePipe,
    private _eref: ElementRef,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.licensePlateClass = this.globalSetting.getGlobalLicencePlate();
    this.getUserDealers();
    this.getBrands().then(() => {
      let language = this.cookieservice.get('userSelectedLanguage');
      this.GetAllWorkOrderStatus(language);
      this.getVehiclePickDropList();
      if (this.vehiclePickDrop.filterTypeId == Constant.TodayView) {
        this.loadTodayView();
      } else if (this.vehiclePickDrop.filterTypeId ==  Constant.WeekView) {
        this.loadWeekView();
      } else {
        this.VehiclePickDropData.BookingDate = null;
      }
    });


  }

  public get documentTypes(): typeof Enums.DocumentsType {
    return Enums.DocumentsType;
  }
  @HostListener('document:click', ['$event'])
  onSearchBoxClose(event) {
    if (event) {
      if (!this._eref.nativeElement.getElementsByClassName('advanced-search-box')[0]?.contains(event.target)) {
        this.isAdvanceSearch = false;
      }
    }
  }
  async getUserDealers() {
    await this.dealerBusinessService
      .getUserDealersDropdown()
      .then((response) => {
        this.dealerList = this.mapdealer(response.userDealersModel);
        this.dealers = this.mapDealerListToDealers(response.userDealersModel);
      });
  }

  public getBrands(): Promise<void> {
    return new Promise((resolve, _reject) => {
      this.brandService.getBrand().then((res) => {
        if (res) {
          this.brandList = res;
        }
        resolve();
      });
    });
  }



  private dataMapper(customerWaitingResponse:VehiclePickupDrop[]) {
    return customerWaitingResponse.map((element, i) => {
      return {

         row : 1 + i,
         appointmentStatus:element.appointmentStatus,
         appointmentStatusColor:element.appointmentStatusColor,
         bookedDate :element.bookedDate,
         bookedDateTime:element.bookedDateTime,
         brandCode :element.brandCode,
         brandName :element.brandName,
         createdDate :element.createdDate,
         createdDateTime :element.createdDateTime,
         customerName :element.customerName,
         dealerId :element.dealerId,
         dealerName :element.dealerName,
         id :element.id,
         mobileCode : element.mobileCode,
         mobileNo: element.mobileNo,
        modelName: element.modelName,
        openingHours: element.openingHours,
        totalCount: element.totalCount,
        workOrderNo: element.workOrderNo,
        workOrderStatusColor: element.workOrderStatusColor,
        workOrderStatusId: element.workOrderStatusId,
      } as VehiclePickupDrop
    });
  }

  private VehiclepickDropExelDataMapper(List: any) {
    let supperArray = [];
    if (List && List.length > 0) {
      for (let index = 0; index < List.length; index++) {
        const element = List[index];
        let single = Object();
        single.No = index + 1;
        single.WoStatus = element.workOrderStatus;
        single.RegistrationNo = element.licensePlate;
        single.WoNo = element.workOrderNo;
        single.CustomerName = element.customerName;
        single.MobileCode = element.mobileCode;
        single.MobilNo = +element.mobileCode + ' ' + element.mobileNo;
        single.DealerName = element.dealerName;
        single.CustomerPickUpTime = element.customerPickupTime;
        single.AppointmentDate = element.bookedDate;
        single.PickUpDateTime = element.pickUpDateTime;
        single.DropOffDateTime = element.dropOffDateTime;
        supperArray.push(single);
      }
    }
    return supperArray;
  }

  onScrollDown(_ev) {
    if (this.totalCount > this.filterList.length) {
      this.VehiclePickDropData.StartRecordNumber = this.VehiclePickDropResponse.length
      this.getVehiclePickDropList();
    }
  }
  getBrandImage(key: any) {
    return this.brandList?.filter(
      (x) => x.brandCode.toUpperCase() === key.toUpperCase()
    )[0];
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.VehiclePickDropData.sortColumn = column;
    this.VehiclePickDropData.sortDirection = direction;
    this.VehiclePickDropData.StartRecordNumber = 0;
    this.PickDropList = [];
    this.spinner.show();
    this.getVehiclePickDropList();
  }

  GetAllWorkOrderStatus(languageCode, fromIntialize: boolean = false) {
    this.spinner.show();
    this.appointmentStatusRequestModel.appointmentStatusId = this.appointmentService.appointmentRequestModel.appointmentStatusId;
    this.appointmentStatusRequestModel.workOrderStatusId = this.appointmentService.appointmentRequestModel.workOrderStatusId;
    this.appointmentStatusRequestModel.dealerId = this.appointmentService.appointmentRequestModel.dealerId;
    this.appointmentStatusRequestModel.languageCode = languageCode;
    this.appointmentStatusRequestModel.licensePlate = this.appointmentService.appointmentRequestModel.licensePlate;
    this.appointmentStatusRequestModel.woNumber = this.appointmentService.appointmentRequestModel.woNumber;
    this.appointmentStatusRequestModel.customerName = this.appointmentService.appointmentRequestModel.customerName;
    this.appointmentStatusRequestModel.mobileNumber = this.appointmentService.appointmentRequestModel.mobileNumber;
    if (fromIntialize) {
      this.appointmentStatusRequestModel.bookingDate = this.appointmentService.appointmentRequestModel.bookingDate;
    }
    else {      
      this.appointmentStatusRequestModel.bookingDate = this.getFormattedDate(this.bookingDate);
      this.appointmentStatusRequestModel.createdDate = this.getFormattedDate(this.createdDate);
    }

    this.appointmentService.GetAllWorkOrderStatus(this.appointmentStatusRequestModel).then(data => {
      this.workOrderStatusList = data.responseObject.workOrderStatusList;
      this.appointmentstatusList = data.responseObject.appointmentStatusList;
    })
    setTimeout(() => {
      this.spinner.hide();
    }, 3000);
  }

  mapdealer(array: UserDealersModel[]) {
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach(element=>{ 
        let single = Object();
        single.value = element.dealerId;
        single.text = element.dealerName;
        supperArray.push(single);
      })
    }
    return supperArray;
  }

  mapDealerListToDealers(array: UserDealersModel[]) {
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach(element=>{
        let single = Object();
        single.dealerId = element.dealerId;
        single.name = element.dealerName;
        supperArray.push(single);
      })
    }
    return supperArray;
  }

  async setPage(pagerData: PagerData) {
    if (
      pagerData == null ||
      pagerData === undefined ||
      pagerData.page < 1 ||
      pagerData.page > this.pager.totalPages
    ) {
      return;
    }
    this.pagerData.page = pagerData.page;
    this.pagerData.pagerSize = pagerData.pagerSize;
  }

  refresh()
  {
    this.VehiclePickDropResponse=[];
    this.getVehiclePickDropList();
  }

  AdvanceSearchSubmit(_event: any) {
    this.VehiclePickDropResponse=[];
    if(this.VehiclePickDropData.BookingFromDate && this.VehiclePickDropData.BookingToDate)
    {
      const bookingdate = this.datePipe.transform(new Date(this.VehiclePickDropData.BookingFromDate), 'dd/MM/yyyy') + ' - ' + this.datePipe.transform(new Date(this.VehiclePickDropData.BookingToDate), 'dd/MM/yyyy');
      this.VehiclePickDropData.BookingDate = bookingdate;
    }
    this.getVehiclePickDropList();
    this.isAdvanceSearch = false;
  }
  onChange(event:any)
  {
    if(typeof event !== 'undefined'){
      const startDate = new Date(event[0]);
      this.VehiclePickDropData.BookingFromDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + 1).toISOString();
    }
    if(typeof event !== 'undefined'){
      const endDate = new Date(event[1]);
      this.VehiclePickDropData.BookingToDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate() + 1).toISOString();
    }
    this.VehiclePickDropData.StartRecordNumber = 0;
  }

  onClickChangeView(isWeek: boolean) {
    if (isWeek) {
      this.loadWeekView();
    } else {
      this.loadTodayView();
    }
  }

  loadTodayView() {
    this.isTodayViewOn = true;
    this.isWeekViewOn = false;
    let todays_date = new Date();
    this.weekViewDate = this.datePipe.transform(todays_date, 'dd/MM/yyyy') + ' - ' + this.datePipe.transform(todays_date, 'dd/MM/yyyy');
    this.bookingDate=[];
    this.bookingDate.push(todays_date);
    this.bookingDate.push(todays_date);
    this.todayViewDate = this.datePipe.transform(new Date(), 'dd/MM/yyyy') + ' - ' + this.datePipe.transform(new Date(), 'dd/MM/yyyy');
    this.VehiclePickDropData.BookingDate = this.todayViewDate;
    this.VehiclePickDropData.StartRecordNumber = 0;
    this.PickDropList = [];
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 3000);
    this.VehiclePickDropResponse=[];
    this.getVehiclePickDropList();
  }

  loadWeekView() {
    this.isTodayViewOn = false;
    this.isWeekViewOn = true;
    let current = new Date();
    let startDay = 1; //0=sunday, 1=monday etc.
    let d = current.getDay(); //get the current day
    let weekStart = new Date(current.valueOf() - (d <= 0 ? 7 - startDay : d - startDay) * 86400000); //rewind to start day
    let weekEnd = new Date(weekStart.valueOf() + 6 * 86400000); //add 6 days to get last day
    this.weekViewDate = this.datePipe.transform(weekStart, 'dd/MM/yyyy') + ' - ' + this.datePipe.transform(weekEnd, 'dd/MM/yyyy');
    this.bookingDate=[];
    this.bookingDate.push(weekStart);
    this.bookingDate.push(weekEnd);
    this.VehiclePickDropData.BookingDate = this.weekViewDate;
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 3000);
    this.VehiclePickDropResponse=[];
    this.getVehiclePickDropList();
  }

  onQuickSerch()
  {
    this.VehiclePickDropData.SearchTerm = this.searchTerm;
    this.spinner.show();
    this.VehiclePickDropResponse=[];
    this.getVehiclePickDropList()
  }

  onDealerChange(dealerId:string)
  {
    this.VehiclePickDropData.DealerId = dealerId;
    this.VehiclePickDropData.StartRecordNumber = 0;
    this.spinner.show();
    this.VehiclePickDropResponse=[];
    this.getVehiclePickDropList();
    this.spinner.hide();
  }
  onStatusChange(status:any) {
    if (status == undefined) {
      this.VehiclePickDropData.WorkOrderStatusId = Enums.WOStatus.All;
    } else {
      this.VehiclePickDropData.WorkOrderStatusId = status;
    }
    this.VehiclePickDropData.StartRecordNumber = 0;
    this.spinner.show();
    this.VehiclePickDropResponse=[];
    this.getVehiclePickDropList();
    this.spinner.hide();
  }

  onSearch() {
    this.isAdvanceSearch = true;
  }

  onReset() {
    this.VehiclePickDropData.AppointmentStatusId = null;
    this.VehiclePickDropData.WorkOrderStatusId = null;
    this.VehiclePickDropData.BookingDate = null;
    this.VehiclePickDropData.createdDate = null;
    this.bookingDate = [];
    this.createdDate = [];
  }

  onClose() {
    this.onReset();
    this.isAdvanceSearch = false;
  }

  public async onDownloadPDF(_pdf: number) {
    this.getVehiclePickDropListDocument(_pdf)
  }

  public async exportAsXLSX(_excel: number) {
    this.getVehiclePickDropListDocument(_excel)
  }
  getVehiclePickDropListDocument(type){
    this.VehiclePickDropData.IsForDocuments = true;
    this.spinner.show();
    this.vehiclePickDrop.getVehiclePickDropList(this.VehiclePickDropData).then(
      (res) => {
       if (res == null) {
         this.spinner.hide();
       }
        this.VehiclePickDropResponseForDocument = this.VehiclepickDropExelDataMapper(res);
        if(type === Enums.DocumentsType.Pdf)
        {
          this.cdr.detectChanges();
          if (this.VehiclePickDropResponseForDocument && this.VehiclePickDropResponseForDocument.length > 0) {
            this.spinner.show();
            this.cdr.detectChanges();
            const doc = new jsPDF();
            autoTable(doc, { html: '#vehiclePdf', margin: { top: 3, left: 3, right: 3, bottom: 3 }, styles: { fontSize: 8 }, columnStyles: { 0: { cellWidth: 9 }, 5: { cellWidth: 25 }, 6: { cellWidth: 15 }, 8: { cellWidth: 22 } } });
            doc.save('VehiclePickDrop_af.pdf');
            this.spinner.hide();
          }
        }
        if(type === Enums.DocumentsType.Excel)
        {
          this.excelService.exportAsExcelFile(this.VehiclePickDropResponseForDocument, 'VehiclePickDrop_af');
        }
       this.VehiclePickDropData.IsForDocuments = false;
        this.spinner.hide();
     }
   );
  }

  async getVehiclePickDropList() {
    this.spinner.show();
    this.vehiclePickDrop.getVehiclePickDropList(this.VehiclePickDropData).then(
      (res) => {
        this.totalCount=0;
        if (res == null || res.errorCount === Constant.ValidationFailure) {
          this.spinner.hide();
          return
        }
        this.filterList.push(...this.dataMapper(res));
          this.VehiclePickDropResponse.push(...res)
        if(this.VehiclePickDropResponse.length>0){
          this.totalCount = this.VehiclePickDropResponse[0].totalCount;
        }
        this.spinner.hide();
      }
    );
  }
  getFormattedDate(dateRangeArray: any[]){
    let formattedDate: string= "";
    if(dateRangeArray.length != 0){
      let beginDate= this.datePipe.transform(dateRangeArray[0], 'dd/MM/yyyy');
      let lastDate= this.datePipe.transform(dateRangeArray[1], 'dd/MM/yyyy');
      formattedDate= beginDate + ' - ' + lastDate;
    }
    return formattedDate;
  }
}
